import React from 'react';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';


const FilterControls = ({ 
  dateRange, 
  onDateRangeChange, 
  deviceType, 
  onDeviceTypeChange,
  geography,
  onGeographyChange,
  onExport,
  onReset
}) => {
  const dateRangeOptions = [
    { value: 'today', label: 'Today' },
    { value: 'yesterday', label: 'Yesterday' },
    { value: 'last7days', label: 'Last 7 Days' },
    { value: 'last30days', label: 'Last 30 Days' },
    { value: 'last90days', label: 'Last 90 Days' },
    { value: 'thisMonth', label: 'This Month' },
    { value: 'lastMonth', label: 'Last Month' },
    { value: 'custom', label: 'Custom Range' }
  ];

  const deviceTypeOptions = [
    { value: 'all', label: 'All Devices' },
    { value: 'desktop', label: 'Desktop' },
    { value: 'mobile', label: 'Mobile' },
    { value: 'tablet', label: 'Tablet' }
  ];

  const geographyOptions = [
    { value: 'all', label: 'All Regions' },
    { value: 'us', label: 'United States' },
    { value: 'uk', label: 'United Kingdom' },
    { value: 'ca', label: 'Canada' },
    { value: 'au', label: 'Australia' },
    { value: 'de', label: 'Germany' },
    { value: 'fr', label: 'France' },
    { value: 'in', label: 'India' },
    { value: 'br', label: 'Brazil' }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 shadow-elevation-sm">
      <div className="flex flex-col lg:flex-row lg:items-end gap-4">
        <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <Select
            label="Date Range"
            options={dateRangeOptions}
            value={dateRange}
            onChange={onDateRangeChange}
          />
          
          <Select
            label="Device Type"
            options={deviceTypeOptions}
            value={deviceType}
            onChange={onDeviceTypeChange}
          />
          
          <Select
            label="Geography"
            options={geographyOptions}
            value={geography}
            onChange={onGeographyChange}
            searchable
          />
        </div>
        
        <div className="flex flex-col sm:flex-row gap-2 lg:flex-shrink-0">
          <Button
            variant="outline"
            iconName="RotateCcw"
            iconPosition="left"
            onClick={onReset}
            className="w-full sm:w-auto"
          >
            Reset
          </Button>
          <Button
            variant="default"
            iconName="Download"
            iconPosition="left"
            onClick={onExport}
            className="w-full sm:w-auto"
          >
            Export CSV
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FilterControls;